"use strict";

exports.__esModule = true;
var _getWidgetColorProps = require("./getWidgetColorProps");
Object.keys(_getWidgetColorProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getWidgetColorProps[key]) return;
  exports[key] = _getWidgetColorProps[key];
});
var _getWidgetCSSProps = require("./getWidgetCSSProps");
Object.keys(_getWidgetCSSProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getWidgetCSSProps[key]) return;
  exports[key] = _getWidgetCSSProps[key];
});
var _getWidgetFontProps = require("./getWidgetFontProps");
Object.keys(_getWidgetFontProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getWidgetFontProps[key]) return;
  exports[key] = _getWidgetFontProps[key];
});
var _getWidgetInteractionProps = require("./getWidgetInteractionProps");
Object.keys(_getWidgetInteractionProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getWidgetInteractionProps[key]) return;
  exports[key] = _getWidgetInteractionProps[key];
});
var _getWidgetPositionProps = require("./getWidgetPositionProps");
Object.keys(_getWidgetPositionProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getWidgetPositionProps[key]) return;
  exports[key] = _getWidgetPositionProps[key];
});
var _ChartCard = require("./ChartCard");
Object.keys(_ChartCard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChartCard[key]) return;
  exports[key] = _ChartCard[key];
});
var _TileContext = require("./TileContext");
Object.keys(_TileContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TileContext[key]) return;
  exports[key] = _TileContext[key];
});